export default "__VITE_ASSET__a39cae70__"